/*
 * @Description: user.api
 * @Author: luozhao
 * @Date: 2021-02-01 14:34:43
 */
import crosRequest from "../../utils-khfw/crosRequestHandler.js";
import api from "@/api/index.js";
import userCenter from "@/utils/userCenter";
import to from "@/utils/await-to";
import reqTip from "@/utils/requestTip";

let ss = sessionStorage;
userCenter.set({
	version: "7.0", // 用户平台版本 6.0/7.0
	isPro: true, // 根据开发环境设置
	loginPlatformCode: ss.loginPlatformCode,
	platformCode: ss.platformCode,
});
/**
 *  6.0获取用户基本信息 aam
 * @param {object} params
 * {
 *  personId: 用户Id String
 * }
 * @returns
 * {
 *  ...
 *  userType: string 6.0用户类型 0:学生 1:老师 2:家长 3:机构 4:学校 5:学校工作人员 6:机构工作人员
 *  ...
 *  userIdentity: string 用户在机构身份: 1:班主任 2:班长 3:管理员 4:教师 5:成员
 *   支持返回多身份，多身份用逗号“，”进行分隔
 *  ...
 * }
 * @memberof User
 */
export function getSixUser(params) {
	return crosRequest({
		method: "post",
		data: {
			intername: "aamif.url",
			requestUri: `/aamif/rest/ticketvalid/${params.ticket}`,
			requestType: "get",
		},
	});
}

/**
 * @description 7.0获取用户信息
 * @author luozhao
 * @returns
 * {
 * ...
 *  7.0用户类型last_user_type 0学生 1老师 2家长 3学校工作人员 4机构人员 5企业人员 12市民
 *  7.0机构类型org_type 1机构 2学校 3校区 4部门 5学段 6年级 7班级 8企业机构 9教学工作室 10平台
 * ...
 * }
 * @memberof User
 */
export function getSevenUser(params) {
	return crosRequest({
		// url:`/account/api/account/verify-ticket-info?ticket=${params.ticket}`,
		// method: "get",
		method: "post",
		data: {
			intername: "addressListV7.url",
			requestUri: `/account/api/account/verify-ticket-info?ticket=${params.ticket}`,
			requestType: "get",
		},
	});
}

export function getOrgLevel(params) {
	return crosRequest({
		method: "post",
		data: {
			intername: "addressListV7.url",
			requestUri: `/msscy/user/level`,
			requestType: "POST",
			params,
		},
	});
}

//通过usessionid获取用户信息 权限
// export async function getUserInfo(params) {
// 	let req = userCenter.RequestHandler({
// 		url: "/user/api/user/get-user-info-by-usession-id",
// 		method: "get",
// 		params,
// 	});
// 	const [err, res] = await to(req);
// 	if (err || !res || res.code != "000000") {
// 		err ? reqTip.showNetworkError(err) : reqTip.showReqError(res, "获取用户数据异常，请稍后再试");
// 		return null;
// 	}
// 	return res.result || {};
// }

//通过user_id获取用户信息 权限
export async function getUserInfo(params) {
	let req = userCenter.RequestHandler({
		url: "/user/api/user/get-user-info",
		method: "get",
		params,
	});
	const [err, res] = await to(req);
	if (err || !res || res.code != "000000") {
		err ? reqTip.showNetworkError(err) : reqTip.showReqError(res, "获取用户数据异常，请稍后再试");
		return null;
	}
	return res.result || {};
}

//通过role_id获取用户角色
export async function getRoleType(params) {
	let req = userCenter.RequestHandler({
		url: "/user/api/role/role-group",
		method: "get",
		params,
	});
	const [err, res] = await to(req);
	if (err || !res || res.code != "000000") {
		err ? reqTip.showNetworkError(err) : reqTip.showReqError(res, "获取用户角色异常，请稍后再试");
		return null;
	}
	return res.result || {};
}
//通过ticket获取用户角色信息
export async function getRoleinfo(params) {
	let req = userCenter.RequestHandler({
		url: `/account/api/account/verify-ticket-info?ticket=${params.ticket}`,
		method: "get",
	});
	const [err, res] = await to(req);
	if (err || !res || res.code != "000000") {
		err ? reqTip.showNetworkError(err) : reqTip.showReqError(res, "获取用户角色异常，请稍后再试");
		return null;
	}
	return res.result || {};
}
export async function getRoleinfo1(params) {
	return api({
		url:`/account/api/account/verify-ticket-info?ticket=${params.ticket}`,
		method: "get",
	});
}